module.exports = __webpack_public_path__ + "img/motorsport.065b0d66.svg";